import React from 'react';
import classnames from 'classnames';

export type TabProps = {
  size: 'small' | 'medium' | 'large';
  shape: 'button' | 'pill';
  selected?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Tab = ({ size, shape, selected = false, className, children, ...props }: TabProps) => {
  const classNames = classnames(
    className,
    'airtame-tab',
    `airtame-tab--${size}`,
    `airtame-tab--${shape}`,
    { 'airtame-tab--selected': selected }
  );
  return (
    <button className={classNames} {...props}>
      {children}
    </button>
  );
};
